import React from "react";

type LoadingType = {
    loadingName: string;
}

const LoadingSpinner: React.FC<LoadingType> = ({ loadingName }) => {
    return (
        <div className="flex justify-center items-center flex-col h-full w-auto" style={{ gap: "2vh" }}>
            {/* Tailwind-based spinner */}
            <div
                className="border-4 border-t-blue-500 border-r-blue-400 border-b-blue-300 border-l-blue-200 rounded-full animate-spin"
                style={{
                    width: "6vh",
                    height: "6vh",
                }}
            />
            <p className="text-white font-bold" style={{ fontSize: "2vh" }}>
                {loadingName}
            </p>
        </div>
    );
};

export default LoadingSpinner;